import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TELLENT_CURRENT_USER } from '@tellent/types';
import { map, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { TellentMembersHttpClient } from './tellent-members.http';
import { TellentMembersActions } from './tellent-members.store';

@Injectable({ providedIn: 'root' })
export class TellentMembersEffects {
  public effects = createEffectFactory(TellentMembersActions, this.actions$);

  public inviteMember$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentMembersActions.inviteMember),
      mergeMap(({ payload }) =>
        this.tellentMembersHttpClient.inviteMember(payload).pipe(
          map(data => TellentMembersActions.inviteMemberSuccess({ payload: data })),
          catchError(error => of(TellentMembersActions.inviteMemberFail({ payload: error }))),
        ),
      ),
    ),
  );

  constructor(
    private tellentMembersHttpClient: TellentMembersHttpClient,
    private actions$: Actions,
  ) {}

  public ngrxOnInitEffects() {
    return TellentMembersActions.fetchCollectionSuccess({
      payload: { data: inject(TELLENT_CURRENT_USER).members || [] },
    });
  }
}
